import * as React from 'react';

import { CartServiceProps } from '../../types';
import { ServiceSummary } from '../../../features/service-summary';

const BaggageDelivery: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<ServiceSummary serviceType="BaggageDelivery" onDelete={onServiceDelete}>
			{content => <>{content}</>}
		</ServiceSummary>
	);
};

export default BaggageDelivery;
